import CONSTANTS from '../../constants';

export function activities(state = null, action) {
    switch (action.type) {
        case CONSTANTS.ACTIONS.CONFIG.GET.ACTIVITIES:
            return action.activities;
        default:
            return state
    }
}